export default "__VITE_ASSET__C5kOcCv8__"